import i18next from 'i18next';

i18next.addResources('en', 'NewAdminModal', {
  title: 'Create new admin',
  adminName: 'Name',
  adminAddress: 'Address'
});
